import { useTranslation } from '@agentguru/i18n';
import { routes } from '../constants';
export function useNavBarRoutes() {
    var t = useTranslation().t;
    return [
        {
            key: 0,
            path: routes.goToFlightsSearch(),
            icon: 'ag-flights',
            label: t('routes.flights'),
            disabled: false,
            matches: [routes.flights],
        },
        {
            key: 1,
            path: routes.goToBookings(),
            icon: 'ag-bookings',
            label: t('routes.bookings'),
            disabled: false,
            matches: [routes.bookings],
        },
    ];
}
